function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Ember from 'ember';
import { hasNativeEmojiSupport, substituteUnicodeForColonified } from '@intercom/embercom-prosemirror-composer/lib/helpers/emoji';
import { MENTION_CLASS } from '../constants';
import { encodeAttributes } from '../attribute-encoding';
export class TextSerializer {
  constructor(schema, config) {
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "text", void 0);
    _defineProperty(this, "nodeNameMap", {
      bold: 'b',
      italic: 'i',
      anchor: 'a',
      code: 'code',
      span: 'span'
    });
    this.schema = schema;
    this.config = config;
    this.text = '';
  }
  serializeNode(containerNode) {
    let openMarks = [];
    containerNode.content.forEach(node => {
      let nodeMarks = node.marks || [];
      nodeMarks = this.filterSerializableMarks(nodeMarks);
      this.maybeCloseMarks(openMarks, nodeMarks);
      switch (node.type) {
        case this.schema.nodes.hardBreak:
          this.text += '<br>';
          break;
        case this.schema.nodes.text:
          this.maybeOpenMarks(openMarks, nodeMarks);
          this.serializeText(node);
          break;
        case this.schema.nodes.template:
          this.maybeOpenMarks(openMarks, nodeMarks);
          this.serializeTemplate(node);
          break;
        case this.schema.nodes.mention:
          this.serializeMention(node);
          break;
        case this.schema.nodes.aiPromptData:
          this.serializeAiPromptData(node);
          break;
        case this.schema.nodes.marker:
          break;
        case this.schema.nodes.inlineImage:
          this.serializeImage(node);
          break;
        default:
          throw new Error('Invalid node type in text');
      }
    });
    this.maybeCloseMarks(openMarks, []);
    return this.text;
  }
  filterSerializableMarks(marks) {
    return marks.filter(mark => {
      let spec = mark.type.spec;
      return spec.serializable !== false;
    });
  }
  maybeCloseMarks(openMarks, nodeMarks) {
    let marksToClose = openMarks.filter(mark => !nodeMarks.includes(mark));
    if (marksToClose.length === 0) {
      return;
    }
    let innerMostMark = openMarks.pop();
    if (!innerMostMark) {
      throw new Error('unreachable');
    }
    this.addClosingTag(innerMostMark.type);
    this.maybeCloseMarks(openMarks, nodeMarks);
  }
  maybeOpenMarks(openMarks, nodeMarks) {
    let marksToOpen = nodeMarks.filter(mark => !openMarks.includes(mark));
    marksToOpen.forEach(mark => {
      openMarks.push(mark);
      this.addOpeningTag(mark);
    });
  }
  serializeText(node) {
    let text = node.text || '';
    if (!hasNativeEmojiSupport()) {
      text = substituteUnicodeForColonified(text);
    }
    this.text += this.escape(text);
  }
  serializeTemplate(node) {
    this.text += `{{${this.escape(node.attrs.attributePath)}`;
    if (node.attrs.fallback) {
      this.text += `|fallback:"${this.escape(node.attrs.fallback)}"`;
    }
    this.text += '}}';
  }
  serializeMention(node) {
    this.text += `<a class="${MENTION_CLASS}" href="${this.escape(node.attrs.uri)}">${this.escape(node.attrs.name)}</a>`;
  }
  serializeAiPromptData(node) {
    let html = '<span data-ai-prompt-data';
    Object.entries(node.attrs).forEach(([key, value]) => {
      if (value) {
        let attrKey = key.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
        html += ` data-prompt-data-${attrKey}="${this.escape(value)}"`;
      }
    });
    this.text += `${html}></span>`;
  }
  serializeImage(node) {
    let {
      displayWidth,
      width,
      src,
      linkUrl,
      text
    } = node.attrs;
    let image = `<img class="${MENTION_CLASS} inline-image" src="${this.escape(src)}" width="${displayWidth || width}"${text ? ` alt="${this.escape(text)}"` : ''}>`;
    if (linkUrl) {
      image = `<a href="${this.escape(linkUrl)}">${image}</a>`;
    }
    this.text += image;
  }
  addClosingTag(markType) {
    this.text += `</${this.nodeNameMap[markType.name]}>`;
  }
  addOpeningTag(mark) {
    this.text += `<${this.nodeNameMap[mark.type.name]}`;
    if (mark.attrs) {
      this.addAttrs(mark);
    }
    this.text += '>';
  }
  addAttrs(mark) {
    Object.keys(mark.attrs).forEach(k => {
      let encoded = encodeAttributes(mark.attrs[k]);
      let value = this.escape(encoded);
      if (value) {
        this.text += ` ${k}="${value}"`;
      }
    });
  }
  escape(text) {
    let handlebars = Ember.Handlebars;
    return handlebars.Utils.escapeExpression(text);
  }
}